export const ptBR = {
  code: "pt",
  metaTitle: "Murilo Lodovico — Engenheiro de Software Full Stack",
  metaDescription:
    "Engenheiro de software full stack em Campinas/SP. Java, TypeScript, React, Spring Boot e arquiteturas modernas. Aberto a posições remotas ou híbridas.",
  skipToContent: "Ir para o conteúdo",
  openMenu: "Abrir menu",
  closeMenu: "Fechar menu",
  langLabel: "Idioma",
  navAbout: "Sobre",
  navExperience: "Experiência",
  navSkills: "Stack",
  navProjects: "Projetos",
  navEducation: "Formação",
  navContact: "Contato",
  role: "Engenheiro de Software Full Stack",
  currentLabel: "Atualmente",
  currentCompany: "NAVA",
  locationLabel: "Cidade",
  location: "Campinas, SP",
  workModeLabel: "Formato",
  workMode: "Remoto ou híbrido",
  heroLead:
    "Projeto e evoluo produtos digitais nas camadas front-end e back-end, com Java, TypeScript e arquiteturas modernas. Foco em qualidade, performance e sistemas que continuam fáceis de manter.",
  ctaExperience: "Ver experiência",
  ctaResume: "Baixar currículo",
  ctaContact: "Falar comigo",
  resume: "Currículo",
  statYears: "6+",
  statYearsLabel: "anos construindo software",
  statStack: "Java + JS",
  statStackLabel: "do domínio ao interface",
  statWork: "Remoto / híbrido",
  statWorkLabel: "Campinas e RMC",
  aboutTitle: "Sobre",
  aboutEyebrow: "Perfil",
  aboutP1:
    "Profissional experiente em desenvolvimento de software, com histórico sólido na criação de funcionalidades robustas, correção eficiente de bugs e aprimoramento contínuo da qualidade de produtos digitais. Atuo de forma integrada nas camadas front-end e back-end, sempre orientado a padrões modernos de arquitetura e boas práticas de engenharia.",
  aboutP2:
    "Especialista em interfaces modernas e performáticas com Next.js, React e Angular, utilizando TypeScript, e com ampla experiência em back-end com Node.js, NestJS e Java (Spring Boot). Aplico DDD na modelagem de domínio, TDD/BDD para validar comportamento e SOLID para garantir extensibilidade, baixo acoplamento e alta coesão.",
  aboutP3:
    "Pratico Arquitetura Limpa, Arquitetura Hexagonal e Clean Code: camadas bem separadas, regras de negócio independentes de detalhes de implementação, e portas e adaptadores para promover modularidade.",
  principlesTitle: "Como eu construo",
  experienceTitle: "Experiência",
  experienceEyebrow: "Trajetória",
  skillsTitle: "Stack",
  skillsEyebrow: "Ferramentas",
  projectsTitle: "Projetos",
  projectsEyebrow: "Seleção",
  projectsIntro:
    "APIs, apps e experimentos que mostram o recorte do que gosto de construir.",
  educationTitle: "Formação",
  educationEyebrow: "Base",
  degreeLabel: "Graduação",
  degreeTitle: "Ciências da Computação",
  degreeSchool: "UNIP",
  degreePeriod: "2018 — 2021",
  degreeDescription:
    "Formação acadêmica em Ciência da Computação, com base em algoritmos, engenharia de software e sistemas.",
  coursesTitle: "Cursos",
  languagesTitle: "Idiomas",
  langEnglish: "Inglês — avançado",
  langSpanish: "Espanhol — básico",
  contactTitle: "Vamos conversar",
  contactEyebrow: "Contato",
  contactLead:
    "Aberto a posições remotas ou híbridas na RMC. Se fizer sentido, me chama.",
  contactEmail: "E-mail",
  contactWhatsapp: "WhatsApp",
  footer: "Campinas, SP",
  viewProject: "Ver no GitHub",
  viewCertificate: "Ver certificado",
  principles: [
    {
      title: "DDD",
      text: "Modelagem de domínio alinhada ao negócio, não só à tecnologia.",
    },
    {
      title: "TDD / BDD",
      text: "Comportamento validado cedo, com testes que protegem a evolução.",
    },
    {
      title: "SOLID",
      text: "Extensibilidade, baixo acoplamento e alta coesão no dia a dia.",
    },
    {
      title: "Clean / Hexagonal",
      text: "Regras de negócio independentes de frameworks, bancos e UI.",
    },
  ],
  experience: [
    {
      company: "NAVA",
      role: "Desenvolvedor Full Stack Pl / Engenheiro de Software",
      period: "set/2024 — atual",
      description:
        "Engenharia backend com foco em Java, Apache Camel e integrações de alto desempenho. Migração de sistemas legados, otimização de performance, modelagem de arquitetura e evolução de aplicações críticas, aplicando DDD, BDD e SOLID.",
      tags: ["Java", "Apache Camel", "DDD", "BDD", "Integrações"],
    },
    {
      company: "Upwork",
      role: "Engenheiro de Software / Desenvolvedor Pl",
      period: "ago/2023 — ago/2024",
      description:
        "Soluções fintech com React, TypeScript, Java e Spring Boot, incluindo sistemas de pagamento e módulos ERP. Responsável por novas funcionalidades, correção de bugs e integração de serviços.",
      tags: ["React", "TypeScript", "Java", "Spring Boot", "Fintech"],
    },
    {
      company: "Coopersystem",
      role: "Engenheiro de Software / Desenvolvedor Pl",
      period: "jan/2022 — ago/2023",
      description:
        "Integração de pacotes React Native com Swift e desenvolvimento de aplicações completas em React Native, da concepção à entrega. Atuação também com Angular, React, TypeScript e Node.js, além de AWS S3 e EC2.",
      tags: ["React Native", "Swift", "Angular", "Node.js", "AWS"],
    },
    {
      company: "Qyon Intelligent Systems",
      role: "Engenheiro de Software / Desenvolvedor Pl",
      period: "abr/2021 — nov/2021",
      description:
        "Liderança no front-end de um aplicativo fintech: páginas e componentes em React Native com TypeScript, reuniões técnicas e definição de novas funcionalidades.",
      tags: ["React Native", "TypeScript", "Fintech"],
    },
    {
      company: "BUTH",
      role: "Desenvolvedor de Software Jr",
      period: "set/2020 — abr/2021",
      description:
        "Telas e correção de bugs com React e React Native, TypeScript, Bootstrap e Styled Components. APIs e recursos back-end com Node.js.",
      tags: ["React", "React Native", "Node.js"],
    },
    {
      company: "Matera Financial Risk Retail",
      role: "Estagiário",
      period: "jan/2019 — dez/2019",
      description:
        "Java Spring Boot no desenvolvimento e correção de bugs em sistemas complexos de ERP, com Docker, Swagger e OracleDB.",
      tags: ["Java", "Spring Boot", "Docker", "Oracle"],
    },
  ],
  skillGroups: [
    {
      title: "Front-end",
      items: ["React", "Next.js", "Angular", "TypeScript", "JavaScript"],
    },
    {
      title: "Back-end",
      items: ["Java", "Spring Boot", "Apache Camel", "Node.js", "NestJS"],
    },
    {
      title: "Mobile",
      items: ["React Native", "Swift"],
    },
    {
      title: "Arquitetura",
      items: ["DDD", "TDD / BDD", "SOLID", "Clean Architecture", "Hexagonal"],
    },
    {
      title: "Cloud e dados",
      items: ["AWS S3", "EC2", "Docker", "MySQL", "MongoDB", "OracleDB", "Swagger"],
    },
  ],
  projects: {
    petshop: "API REST de petshop com NestJS, TypeORM e MySQL.",
    checkIns: "API de check-ins em Java Spring Boot, com Lombok e boas práticas de API.",
    goBarber: "Sistema de barbearia com React, React Native e Node.",
    gitHunter: "Busca de perfis no GitHub por ID, feito em React.",
    mostUsedWords: "Contagem de palavras em um texto, construído com Vue.js.",
    habits: "Marcador de hábitos e compromissos em React.",
  },
  courses: [
    {
      title: "Java — Programação Orientada a Objetos",
      subtitle: "02/2023 — 08/2023",
    },
    {
      title: "Web Moderno Completo com JavaScript",
      subtitle: "Udemy · 08/2021 — 05/2022",
    },
    {
      title: "Swift App Development Bootcamp",
      subtitle: "02/2021 — 07/2021",
    },
    {
      title: "Rocketseat GoStack",
      subtitle: "01/2020 — 11/2020",
    },
    {
      title: "Linguagem Python",
      subtitle: "Udemy · 03/2019 — 04/2019",
    },
  ],
};
